// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How an integer is narrowed after it is read.
 */
export enum Narrow {
  None = 0,
  SignExtendWide = 1,
  U32AsI32 = 2,
  CheckedI32 = 3,
  CheckedU32 = 4,
  CheckedU8 = 5,
}
